import { MapUtils } from '../../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';

export class TargetAudienceRule extends DataModel {
  static readonly TYPE_ID: string = '71bd622df5b6473686779257558bbcac';

  private constructor(
    public readonly city: string,
    public readonly adAccountId: string,
    public readonly metaId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return TargetAudienceRule.TYPE_ID;
  }

  static create(args: {
    city: string,
    adAccountId: string,
    metaId: string,
  }): TargetAudienceRule {
    return new TargetAudienceRule(
        args.city,
        args.adAccountId,
        args.metaId,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): TargetAudienceRule {
    return TargetAudienceRule.create({
      city: MapUtils.getString(map, 'city'),
      adAccountId: MapUtils.getString(map, 'adAccountId'),
      metaId: MapUtils.getString(map, 'metaId'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'city': this.city,
      'adAccountId': this.adAccountId,
      'metaId': this.metaId,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    city = this.city,
    adAccountId = this.adAccountId,
    metaId = this.metaId,
  }: {
    city?: string,
    adAccountId?: string,
    metaId?: string,
  } = {}): this {
    return TargetAudienceRule.create({
      city,
      adAccountId,
      metaId,
    }) as this;
  }

  isSame(other: TargetAudienceRule): boolean {
    if(other === this) {
      return true;
    }

    return other.city === this.city &&
      other.adAccountId === this.adAccountId &&
      other.metaId === this.metaId;
  }
}

export class TargetAudienceRuleBuilder extends DataModelBuilder<TargetAudienceRule> {
  build(context: SerializationContext, map: SerializedData): TargetAudienceRule {
    return TargetAudienceRule.fromMap(context, map);
  }
}
